import { render, staticRenderFns } from "./cricket-vs-corona.vue?vue&type=template&id=18347040&scoped=true&"
var script = {}
import style0 from "./cricket-vs-corona.vue?vue&type=style&index=0&id=18347040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18347040",
  null
  
)

export default component.exports